module.exports = __webpack_public_path__ + "media/svg/phone-250e3312.svg";